export default __webpack_public_path__ + "static/media/iconLocationDark.36e245ba.svg";